import React from 'react';
import { useForm } from '../FormContext';

/**
 * This is the Higher Order Component Pattern
 * This returns a new components that will conditionally render based on a condition which accepts formValues as the argument
 * 
 * ex: MyConditionlFormField = withConditionalFormField((formValues) => true)(DynamicFormField);
 */ 
export const withConditionalRender = (condition) => (WrappedComponent) => {
  return (props) => {
    const { formValues } = useForm();

    if (condition(formValues)) {
      return <WrappedComponent {...props} />;
    }

    return null;
  };
};
